import React, { useEffect, useState } from "react"
import { View } from "react-native"
import { AnimatedRollingNumber } from "react-native-animated-rolling-numbers"
import { Text } from "react-native-paper"
import { Easing } from "react-native-reanimated"
import { theme } from "../../theme/theme"
import { Clock, Feather, Petal, SkillSetTitle, Xp } from "../icons/IconsM"
import TextM from "../text/TextM"

export function XPCounter(props) {
    const { count, totalCount, style, level } = props
    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                height: 48,
                ...style,
            }}
        >
            <Xp size={30} />
            <TextM
                color={theme.colors.white}
                fontWeight="ExtraBold"
                fontSize={16}
                style={{ marginBottom: 2 }}
            >
                {count}
            </TextM>
            <TextM
                color={theme.colors.white}
                fontWeight="SemiBold"
                fontSize={12}
            >
                {" /" + totalCount}
            </TextM>
            <TextM
                color={theme.colors.accent}
                fontWeight="SemiBold"
                fontSize={10}
                style={{
                    position: "absolute",
                    top: 0,
                    left: 20,
                }}
            >
                NIVEAU {level}
            </TextM>
        </View>
    )
}
export function FeatherCounter(props) {
    const { count, style } = props
    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                ...style,
            }}
        >
            <Feather size={26} />
            <Text
                style={{
                    color: theme.colors.accentDark,
                    fontFamily: "Montserrat-ExtraBold",
                    alignContent: "center",
                    fontSize: 18,
                }}
            >
                {count}
            </Text>
        </View>
    )
}

const getCurrentCount = (count, bonus, canStartAnimation) => {
    if (bonus > 0 && !canStartAnimation) {
        return count - bonus
    } else {
        return count
    }
}

export function PetalCounter(props) {
    const {
        count,
        small = false,
        style,
        petalsGained = 0,
        canStart = true,
        onAnimationComplete = () => {},
        animationDuration = 1000,
    } = props

    let { iconSize, fontSize } = props

    fontSize = fontSize ? fontSize : !small ? 16 : 14
    iconSize = iconSize ? iconSize : !small ? 25 : 21

    const [displayedPetals, setDisplayedPetals] = useState(
        getCurrentCount(count, petalsGained, canStart)
    )

    useEffect(() => {
        setDisplayedPetals(getCurrentCount(count, petalsGained, canStart))
    }, [count, petalsGained, canStart])

    useEffect(() => {
        if (petalsGained > 0 && canStart) {
            setDisplayedPetals(count)
            setTimeout(() => {
                onAnimationComplete()
            }, animationDuration)
        }
    }, [petalsGained, canStart, count, animationDuration, onAnimationComplete])

    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                ...style,
            }}
        >
            <Petal size={iconSize} />
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                }}
            >
                {petalsGained ? (
                    <AnimatedRollingNumber
                        value={displayedPetals}
                        showPlusSign
                        textStyle={{
                            color: theme.colors.petalNew,
                            fontSize,
                            fontFamily: small
                                ? "Montserrat-Bold"
                                : "Montserrat-ExtraBold",
                            textAlign: "right",
                        }}
                        spinningAnimationConfig={{
                            duration: animationDuration,
                            easing: Easing.bounce,
                        }}
                    />
                ) : (
                    <Text
                        style={{
                            color: theme.colors.petalNew,
                            fontFamily: small
                                ? "Montserrat-Bold"
                                : "Montserrat-ExtraBold",
                            fontSize,
                            textAlign: "right",
                        }}
                    >
                        {displayedPetals}
                    </Text>
                )}
            </View>
        </View>
    )
}

export function XPCount(props) {
    const {
        count,
        style,
        small = false,
        right = false,
        heightFirst = false,
        xPGained = 0,
        canStart = true,
        onAnimationComplete = () => {},
        animationDuration = 1000,
    } = props

    let { iconSize, fontSize } = props

    fontSize = fontSize ? fontSize : !small ? 16 : 14
    iconSize = iconSize ? iconSize : !small ? 25 : 21

    const [displayedXP, setDisplayedXP] = useState(
        getCurrentCount(count, xPGained, canStart)
    )

    useEffect(() => {
        setDisplayedXP(getCurrentCount(count, xPGained, canStart))
    }, [count, xPGained, canStart])

    useEffect(() => {
        if (xPGained > 0 && canStart) {
            setDisplayedXP(count)
            setTimeout(() => {
                onAnimationComplete()
            }, animationDuration)
        }
    }, [xPGained, canStart, count, animationDuration, onAnimationComplete])

    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                ...style,
            }}
        >
            {!right && (
                <View>
                    <Xp size={iconSize} heightFirst={heightFirst} />
                </View>
            )}
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                }}
            >
                {xPGained ? (
                    <AnimatedRollingNumber
                        value={displayedXP}
                        showPlusSign
                        textStyle={{
                            color: theme.colors.accent,
                            fontSize,
                            fontFamily: small
                                ? "Montserrat-Bold"
                                : "Montserrat-ExtraBold",
                            textAlign: "right",
                        }}
                        spinningAnimationConfig={{
                            duration: animationDuration,
                            easing: Easing.bounce,
                        }}
                    />
                ) : (
                    <Text
                        style={{
                            color: theme.colors.accent,
                            fontFamily: small
                                ? "Montserrat-Bold"
                                : "Montserrat-ExtraBold",
                            fontSize,
                            textAlign: "right",
                            marginLeft: right ? 0 : 4,
                        }}
                    >
                        {displayedXP}
                    </Text>
                )}
            </View>
            {right && (
                <View>
                    <Xp size={iconSize} heightFirst={heightFirst} />
                </View>
            )}
        </View>
    )
}

export function ChronometerCounter(props) {
    const { time, style, small = false, right = false } = props

    let { iconSize, fontSize } = props

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60)
        const secs = seconds % 60
        return `${minutes < 10 ? "0" : ""}${minutes}:${
            secs < 10 ? "0" : ""
        }${secs}`
    }

    fontSize = fontSize ? fontSize : !small ? 16 : 14
    iconSize = iconSize ? iconSize : !small ? 25 : 21

    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                ...style,
            }}
        >
            {!right && (
                <View>
                    <Clock size={iconSize} />
                </View>
            )}
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                }}
            >
                <Text
                    style={{
                        color: theme.colors.chronoBlue,
                        fontFamily: small
                            ? "Montserrat-Bold"
                            : "Montserrat-ExtraBold",
                        fontSize,
                        textAlign: "right",
                        marginLeft: right ? 0 : 4,
                    }}
                >
                    {formatTime(time)}
                </Text>
            </View>
            {right && (
                <View>
                    <Clock size={iconSize} />
                </View>
            )}
        </View>
    )
}

export function SkillSetTitleFull(props) {
    const {
        title,
        skillSetId,
        icon,
        style,
        large = false,
        small = false,
        right = false,
    } = props
    const color =
        skillSetId === 1
            ? theme.colors.zoe
            : skillSetId === 3
            ? theme.colors.sam
            : skillSetId === 2
            ? theme.colors.abou
            : theme.colors.tina
    return (
        <View
            style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                ...style,
            }}
        >
            {!right && (
                <SkillSetTitle
                    size={small ? 20 : large ? 32 : 28}
                    icon={icon}
                />
            )}
            <Text
                style={{
                    color: color,
                    fontFamily: small
                        ? "Montserrat-Bold"
                        : "Montserrat-ExtraBold",
                    alignContent: "center",
                    fontSize: small ? 12 : large ? 16 : 14,
                    marginRight: right ? 0 : 4,
                    marginLeft: right ? 4 : 0,
                    flexWrap: "wrap",
                }}
            >
                {title}
            </Text>
            {right && <SkillSetTitle size={small ? 20 : 28} icon={icon} />}
        </View>
    )
}
